<template>
  <div class="app_container" :class="{ 'list-drag': dragaable }">
    <div>
      <search @search="search" />
    </div>
    <div class="other-deal">
      <butn btntype="primary" title="新增" @click="add" />
      <butn btntype="primary" title="分组列表" @click="goGroupList" />
      <el-checkbox :disabled="dragDisabled" v-model="dragaable" class="drag-box"
        >拖拽排序</el-checkbox
      >
    </div>
    <Table
      :data="tableList"
      :isParty="isParty"
      @deleteSmallClass="deleteSmallClass"
      @editSmallClass="editSmallClass"
    />
    <butn
      class="back-button"
      btntype="primary"
      iconName="el-icon-arrow-left"
      title="返回"
      @click="goBack"
    ></butn>
    <AddSmallClass
      :addDiaInfo="addDiaInfo"
      :classId="classId"
      :className="className"
      :smallClassNum="smallClassNum"
      @addSmallClass="addSmallClass"
      @closeDia="closeDia"
      v-if="addDiaInfo.show"
    />
    <EditSmallClass
      :className="className"
      :editDiaInfo="editDiaInfo"
      :classId="classId"
      @changeSmallClass="changeSmallClass"
      @closeEdit="closeEdit"
      v-if="editDiaInfo.show"
    />
  </div>
</template>

<script>
import Search from "./search.vue";
import butn from "@/components/button/index";
import Table from "./table.js";
import {
  saveSmallClass,
  smallClassList,
  SmallClassDrag,
  delSmallClass,
  updateSmallClass,
} from "@/api/groupManage";
import AddSmallClass from "./addSmallClass.vue";
import EditSmallClass from "./editSmallClass.vue";
import Sortable from "sortablejs";

export default {
  components: {
    Search,
    butn,
    Table,
    AddSmallClass,
    EditSmallClass,
  },
  data() {
    return {
      dragaable: false,
      tableList: [],
      classId: "",
      isParty: null,
      className: "",
      addDiaInfo: {
        show: false,
        title: "新增小班",
      },
      queryParams: {},
      smallClassNum: 0,
      editDiaInfo: {
        show: false,
        title: "编辑小班",
        classChildName: "",
      },
      nowSmallClass: {},
      sort: null,
      groupSourceType: null,
    };
  },
  watch: {
    dragaable(val) {
      this.rowDrop(val);
    },
  },
  computed: {
    dragDisabled() {
      return false;
    },
  },
  created() {
    let {
      id: classId,
      isParty,
      className,
      groupSourceType,
    } = this.$route.query;
    this.classId = classId;
    this.isParty = isParty;
    this.className = className;
    this.groupSourceType = groupSourceType;
    this.$nextTick(() => {
      this.search();
    });
  },
  methods: {
    rowDrop(flag) {
      if (!flag) {
        this.sort && this.sort.destroy();
      } else {
        const _this = this;
        const tbody = document.querySelector(".el-table__body-wrapper tbody");
        this.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",
          // 开始拖拽的时候
          onEnd({ oldIndex, newIndex }) {
            if (oldIndex === newIndex) return;
            console.log("old, new:", oldIndex, newIndex);
            const oldRow = _this.tableList[oldIndex];
            let offset = oldIndex - newIndex;
            let params = {
              offset,
              uuid: oldRow.uuid,
            };
            SmallClassDrag(params).then((res) => {
              if (!res || res.code != 0) return;
              _this.$message({
                message: "排序成功",
                type: "success",
              });
              _this.reload();
              _this.dragaable = false;
            });
          },
        });
      }
    },
    editSmallClass(row) {
      this.nowSmallClass = row;
      this.editDiaInfo.classChildName = row.classChildName;
      this.editDiaInfo.show = true;
    },
    closeEdit() {
      this.editDiaInfo.show = false;
    },
    changeSmallClass(childName) {
      updateSmallClass({ childName, uuid: this.nowSmallClass.uuid }).then(
        ({ code, msg }) => {
          if (code !== 0) return;
          this.editDiaInfo.show = false;
          this.reload();
          this.$message.success(msg);
        }
      );
    },
    deleteSmallClass(row) {
      let { uuid } = row;
      this.$confirm(`确认要删除该小班吗?`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        delSmallClass({ uuids: [uuid] }).then(({ code }) => {
          if (code !== 0) return;
          this.reload();
        });
      });
    },
    closeDia() {
      this.addDiaInfo.show = false;
    },
    add() {
      if (this.smallClassNum === 10) {
        this.$message.warning("最多建立10个小班!");
      } else {
        this.addDiaInfo.show = true;
      }
    },
    search(params = {}) {
      this.queryParams = params;
      smallClassList({ classId: this.classId, ...params }).then(
        ({ code, data }) => {
          if (code !== 0) return;
          this.tableList = data;
          this.smallClassNum = data.length;
        }
      );
      // $router.push$router.push;
    },
    goGroupList() {
      this.$router.push({
        path: "/offlineClass/groupList",
        query: {
          id: this.classId,
          className: this.className,
          groupSourceType: this.groupSourceType || 1,
          isParty: this.isParty || 0,
          isSamllClass: 1,
        },
      });
    },
    reload() {
      this.refreshNowPage(this.queryParams);
    },
    refreshNowPage(params = {}) {
      this.tableList = [];
      this.search(params);
    },
    addSmallClass(childName) {
      saveSmallClass({ classId: this.classId, childName }).then(({ code }) => {
        if (code !== 0) return;
        this.refreshNowPage(this.queryParams);
        this.addDiaInfo.show = false;
      });
    },
    // 点击返回
    goBack() {
      this.$router.back();
    }
  },
};
</script>

<style lang="scss" scoped>
.other-deal {
  float: left;
}
.drag-box {
  margin-left: 10px;
}
.back-button {
  float: left;
  margin-top: 10px;
}
</style>
